/* global helper, url */

// main object
$(function(){
    // авторизация по коду авторизации auth, переданному в адресной строке (используется при переключениями между доменами)
    var set_auth_cookie = mo.getHash('set_auth_cookie');
    if(set_auth_cookie){
        $.cookie('auth', set_auth_cookie, {path: '/'});

        location.hash = '';
        location.reload();
    }

    mo.$information = $('#information');
    mo.user.id = $('#user_id').val();
    mo.user.group = $('#user_group').val();
    mo.user.ip = $('#user_ip').val();
    mo.user.right =[];
    if($('#user_right').length){
        mo.user.right = JSON.parse($('#user_right').val());
    }
    mo.user.yandex_xml_balance = $('#yandex_xml_balance').val();
    if($('#guest_key').length) mo.user.guest_key = $('#guest_key').val(); // гостевой ключ
    mo.pagelang = $('#page_lang').val();

    var information = mo.getHash('information');
    if(information){
        mo.information_add(information, 3);
        mo.setHash('information', '');
    }

    setTimeout(function(){
        if($('#notice_popup').length) $('#notice_popup').dialog({width: 500}).css('min-height', '0');
    });
});

var mo = {};
mo.user = {};
mo.searchers = ['Yandex', 'Google', 'go.Mail', 'Sputnik', 'Youtube', 'Bing', 'Yahoo'];

// получить переменную из GET параметров
mo.getParam = function(name, string){
    if(string == undefined) string = location.href;

    var re = new RegExp('[#?&]' + name + '=([^&#]*)');
    var value = string.match(re);
    if(!value || value.length != 2) return false;

    // if(navigator.userAgent.indexOf('Firefox') == -1) value[1] = url.decode(value[1]); // не Fx

    return value[1];
};

// получить переменную из хэша адресной строки
mo.getHash = function(name, string){
    if(string == undefined) string = location.hash;

    var re = new RegExp('[#?&]' + name + '=([^&]*)');
    var value = string.match(re);
    if(!value || value.length != 2) return false;
    // console.log(value[1]);
    // if(navigator.userAgent.indexOf('Firefox') == -1) value[1] = url.decode(value[1]); // не Fx

    return value[1];
};

// установить значение в хэш параметр страницы
mo.setHash = function(name, value){
    var hash = location.hash;
    var re = new RegExp(name + '=[^&]*', 'g');
    hash = hash.replace(re, '');

    if(value != null) hash += '&' + name + '=' + value;
    hash = hash.replace(/&&/g, '&');
    hash = hash.replace(/&$/, '');

    location.hash = hash;
};

// удалить значение из хэш параметр страницы
mo.remHash = function(name){
    var hash = location.hash;
    var re = new RegExp(name + '=[^&]*', 'g');
    hash = hash.replace(re, '');

//	if(value != null) hash += '&'+name+'='+value;
    hash = hash.replace(/&&/g, '&');
    hash = hash.replace(/&$/, '');

    location.hash = hash;
};

// установить переменные GET
mo.setParam = function(name, val){
    var res = '';
    var d = location.href.split("#")[0].split("?");
    var base = d[0];
    var query = d[1];
    if(query){
        var params = query.split("&");
        for(var i = 0; i < params.length; i++){
            var keyval = params[i].split("=");
            if(keyval[0] != name){
                res += params[i] + '&';
            }
        }
    }
    res += name + '=' + val;

    window.history.pushState({"new": "page"}, document.title, base + '?' + res);
    //window.location.href = base + '?' + res;
    return false;
};

// обновить картинки капчи
mo.captcha_refresh = function(){
    $.map($('.captcha img'), function(el){
        var src = $(el).attr('src');
        src = src.replace(/\?.*/, '');
        src = src + '?ts=' + Math.ceil(Math.random() * 10000);
        $(el).attr('src', src);
    });
    $('.captcha input').val('');
};

mo.get = function(func, module, f, data, show_error){
    if(!func) func = function(){
    };
    if(f == undefined) f = '';
    if(f) f = '&func=' + f;
    if(data == undefined) data = {};
    if(show_error == undefined) show_error = true;

    if(mo.user.guest_key) data.guest_key = mo.user.guest_key;

    if(show_error){
        func_complite = function(data, textStatus, jqXHR){
            if(data.error){
                if(data.message == 'Access error'){
                    location.href = "/";
                    return;
                }

                $('.preloader').hide();
                clearInterval(mo.preloader_t);
                mo.information_add(data.message, 1);
            }
            func(data, textStatus, jqXHR);
        };
    }else{
        func_complite = function(data, textStatus, jqXHR){
            if(data.error && data.message == 'Access error'){
                location.href = "/";
                return;
            }
            func(data, textStatus, jqXHR);
        };
    }

    return $.post(
        '/ajax/get.php?getFormat=json&module=' + module + f,
        data,
        func_complite,
        'json'
    );
};

mo.edit = function(func, module, f, data, show_error){
    if(!func) func = function(){
    };
    if(f == undefined) f = '';
    if(f) f = '&func=' + f;
    if(data == undefined) data = {};
    if(show_error == undefined) show_error = true;
    if(data.oper == undefined) data.oper = 'edit';
    if(data.id == undefined) data.id = '';

    if(show_error){
        func_complite = function(data, textStatus, jqXHR){
            if(data.error){
                if(data.message == 'Access error'){
                    location.href = "/";
                    return;
                }

                $('.preloader').hide();
                clearInterval(mo.preloader_t);
                mo.information_add(data.message, 1);
            }
            func(data, textStatus, jqXHR);
        };
    }else{
        func_complite = function(data, textStatus, jqXHR){
            if(data.error && data.message == 'Access error'){
                location.href = "/";
                return;
            }
            func(data, textStatus, jqXHR);
        };
    }

    return $.post(
        '/ajax/edit.php?getFormat=json&module=' + module + f,
        data,
        func_complite,
        'json'
    );
};

// Перенести аттрибуты объекта в шаблон
mo.toTemplate = function(object, $template, numberWhithWord, setId){
    if(setId == undefined) setId = true;

    $.map(object, function(value, name){
        if(value == null) return;
        if(numberWhithWord && !isNaN(value))
            value = helper.numberWhithWord(value);

        $('.' + name, $template).html(value);
    });
    if(setId && object.id != undefined) $template.addClass('id' + object.id).data('id', object.id);
};

// Ошибки форм
mo.formGo = function($form){
    $('.error-message', $form).remove();
    $('.error', $form).removeClass('error');
    //$form.css('display', 'inline-block');
    $('input[type=submit]', $form).attr('disabled', 'disabled');
};
mo.formStop = function($form){
    $('input[type=submit]', $form).removeAttr('disabled');
    return false;
};
mo.formInsertError = function(text, $el){
    var html = '<p class="error-message"><!--button type="button" class="close" data-dismiss="alert">×</button-->' + text + '</p>';
    $el.addClass('error').after(html);
    return false;
};

// Информационные сообщения
mo.information_add = function(text, status){
    if(!mo.$information.length) return;

    var _class = '';
    if(status == 1) _class = 'alert-error';
    if(status == 2) _class = 'alert-success';
    if(status == 3) _class = 'alert-info';

    var id = helper.getRandomHash();
    var $html = $('<div id="' + id + '" class="alert ' + _class + '"><a href="." class="icon-remove close" title="Закрыть сообщение"></a>' + text + '</div>').hide();
    mo.$information.prepend($html);
    $html.slideDown();
    //helper.animateScrollTo(id);

    $('.close', $html).click(function(event){
        event.preventDefault();
        $html.slideUp(function(){
            $html.remove();
        });
    });

    $('a:not(.close)', $html).click(function(){
        $('.close', $html).click();
    });

    if($('.alert', mo.$information).length > 3) $('.close', mo.$information).last().click();
};

// Отобразить информационное окно
mo.showInfo = function(html, params){
    var params_def = {
        title: 'Системное сообщение',
        buttons: {
            "Ок": function(){
                $(this).dialog("close");
            }
        }
    };

    if(params != undefined)
        params = $.extend(true, params_def, params);

    var $dialog = $("<div>" + html + "</div>").dialog(params);
    $('.button, .button_mini', $dialog).button();

    return $dialog;
};

// Добавление ссылки на css файл в head страницы
mo.addCss = function(file){
    var cssLink = $('<link href="' + file + '" type="text/css" rel="Stylesheet" />');
    $("head").append(cssLink);

    if($("link[href='" + file + "']").size() > 1){
        $("link[href='" + file + "']:first").remove();
    }
};

// Добавление css правила в head страницы
mo.addCssRule = function(selector, style){
    var style_id = helper.getHashStr(selector + style.replace(/:.*?(;|$)/g, ';'));

    $style = $('#' + style_id);
    if(!$style.length) $style = $('<style id="' + style_id + '">').appendTo('head');

    $style.html(selector + '{' + style + '}');
};

// Информация о загрузке
mo.preloader = function(show, $preloader, no_spin){
    if(no_spin == undefined) no_spin = false;
    if(show == undefined) show = true;

    var preloader_inner_html = '<div class="preloader-window"><span class="icon-spin"></span></div>';

    if($preloader == undefined)
        $preloader = $('#preloader');
    if($('> .preloader', $preloader).length)
        $preloader = $('> .preloader:eq(0)', $preloader);
    if($('.preloader', $preloader).length)
        $preloader = $('.preloader:eq(0)', $preloader);
    else if(!$preloader.is('.preloader')){
        if($preloader.css('position') == 'static') $preloader.css('position', 'relative');
        $preloader = $('<div class="preloader">' + preloader_inner_html + '</div>').appendTo($preloader);
    }
    if($preloader.html() == '')
        $preloader.html(preloader_inner_html);

    // масштаба прелоадера
    var k = 0.2;
    if($preloader.height() < 300) k = 0.7;
    var size = Math.round($preloader.height() * k);
    if(size > 74) size = 74;
    $('.icon-spin', $preloader).css({
        'font-size': size,
        width: size,
        height: size,
        'margin-top': -size / 2,
        'margin-left': -size / 2
    });

    if(show){
        var i = 1;
        var p = 1;
        // clearInterval(mo.preloader_t);
        // mo.preloader_t = setInterval(function(){
        //     mo.setFavIcon('image/png', '/images/favicon/loading' + i + '.png');
        //     (p) ? i++ : i--;
        //     if(i == 7) p = 0;
        //     if(i == 1) p = 1;
        // }, 80);

        $preloader.show();
        if(no_spin)
            $('.icon-spin', $preloader).hide();
        else
            $('.icon-spin', $preloader).show();
    }else{
        // clearInterval(mo.preloader_t);
        // mo.setFavIcon('image/x-icon', '/images/favicon/favicon.ico');

        $preloader.hide();
    }
};

mo.setFavIcon = function(type, href){
    var $favicon = $('head link[rel="shortcut icon"]');
    $favicon
    .attr('type', type)
    .attr('href', href);
};

// забрать параметры со страницы
mo_after_init();